<div class="sticky-wrapper">
  @if (!route) {
    <button
      mat-fab
      color="accent"
      matTooltipPosition="above"
      [matTooltip]="label"
      [attr.aria-label]="label"
      [disabled]="disabled"
      (click)="onTriggerAction()">
      <mat-icon>
        {{icon}}
      </mat-icon>
    </button>
  }

  @if (route) {
    <a
      mat-fab
      color="accent"
      matTooltipPosition="above"
      [matTooltip]="label"
      [routerLink]="route"
      [attr.aria-label]="label"
      [disabled]="disabled"
      (click)="onTriggerAction()">
      <mat-icon>
        {{icon}}
      </mat-icon>
    </a>
  }
</div>
